import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { HideScrollbar } from '../../global/commonStyle';

interface Props {
  isCompletedTasksOpen?: boolean;
  isActive?: boolean;
  isWeekend?: boolean;
  isOver?: boolean;
}

const Main = styled.div<Props>`
  display: flex;
  flex-direction: column;
  min-width: 220px;
  width: 100%;
  cursor: pointer;
  &:hover {
    background-color: var(--neutral-secondary);
    .date-text {
      color: var(--brand-primary);
    }
    .hide-show-task-text {
      display: flex;
    }
  }

  ${(props: Props) =>
    props.isCompletedTasksOpen &&
    css`
      .hide-show-task-text {
        display: flex;
      }
    `}

  ${(props: Props) =>
    props.isActive &&
    css`
      background-color: var(--neutral-secondary);
      .date-text {
        color: var(--brand-primary);
      }
      .hide-show-task-text {
        display: flex;
      }
    `}
  ${(props: Props) =>
    props.isWeekend &&
    css`
      min-width: 70px;
      max-width: 70px;
    `}
  ${(props: Props) =>
    props.isOver &&
    css`
      background-color: var(--neutral-secondary);
      .date-text {
        color: var(--brand-primary);
      }
    `}
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  /* align-items: center; */
  padding-inline: var(--space-8);
  height: calc(100vh - 146px);
  ${HideScrollbar}
  :last-child {
    padding-bottom: var(--space-8);
  }
  ${mobile_xl(css`
    :last-child {
      padding-bottom: var(--space-96);
    }
    height: calc(100vh - 190px);
  `)}
`;
const ShowHide = styled.a`
  display: none;
  width: max-content;
  ${Typography.body_md}
  color: var(--text-secondary);
  cursor: pointer;
  padding-block: var(--space-4);
  &:hover {
    color: var(--text-primary);
  }
`;
export { Main, Bottom, ShowHide };
